// extracted by mini-css-extract-plugin
module.exports = {"EventBoard":"EventBoard_EventBoard__Usqt2"};